var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNursingIcone1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "256px",
    height: "256px",
    viewBox: "0 0 31.947 31.947",
    xmlSpace: "preserve",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.836,0C11.341,0,7.187,1.949,3.805,4.816c-1.732,1.469-2.318,3.892-1.444,5.988l2.064,4.95 c1.973-4.335,6.34-7.349,11.411-7.349c5.195,0,9.651,3.16,11.551,7.662l2.199-5.275c0.87-2.088,0.296-4.497-1.422-5.969 C24.732,1.88,20.467,0,15.836,0z M18.323,5.63h-1.448v1.519h-2.022V5.63h-1.521V3.605h1.521v-1.52h2.022v1.52h1.448V5.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.398,11.43c-0.001,0.001-0.003,0.003-0.003,0.004c0,0-3.613,5.666-9.809,7.72c-0.249,0.082-0.522-0.01-0.67-0.229 c-0.146-0.217-0.132-0.506,0.038-0.706c0.273-0.321,0.55-0.68,0.794-1.057c0.179-0.277,0.169-0.636-0.025-0.903 c-0.194-0.267-0.533-0.386-0.853-0.3c-1.904,0.512-4.984,1.946-6.003,5.93c0.484,5.634,5.209,10.058,10.968,10.058 c6.083,0,11.013-4.93,11.013-11.014C26.849,16.882,24.658,13.342,21.398,11.43z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNursingIcone1);
export default __webpack_public_path__ + "static/media/NursingIcone1.a62febd9a39837b7e7fc83dbd56ac4ce.svg";
export { ForwardRef as ReactComponent };